"use client";
import React, { useRef } from "react";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Food1 from "../../../../public/assets/client/food/capital-foods.png";
import Food2 from "../../../../public/assets/client/food/gd-foods.png";
import Food3 from "../../../../public/assets/client/food/dabur.webp";
import Food4 from "../../../../public/assets/client/food/masterchow.png";
import Food5 from "../../../../public/assets/client/food/vrb.png";

gsap.registerPlugin(ScrollTrigger);

const clientImages = [Food1, Food2, Food3, Food4, Food5];

const FoodClientsMobile = () => {
  const sectionRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      { breakpoint: 1280, settings: { slidesToShow: 4 } },
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section
      className="bg-white pb-[50px] pt-[60px] !mb-3 overflow-x-hidden block xl:hidden"
      ref={sectionRef}
    >
      <div className="container mx-auto">
        <h2 className="title !text-center !mb-5 !text-[#033b6f]">
          Our <span className="text-[#d42427]"> Clients</span>
        </h2>

        <Slider {...settings}>
          {clientImages.map((img, i) => (
            <div key={i} className="px-3">
              <div className="border border-gray-200 shadow-2xl rounded-lg p-2 bg-white transition-all duration-300 hover:scale-105">
                <Image
                  src={img}
                  alt={`client-${i}`}
                  className=" rounded-lg object-contain"
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default FoodClientsMobile;
